<div class="row">
  <div class="col-10">
    <label class="secondary-details">{{ labelName }}</label>
  </div>
  <div class="col-2 text-end">
    <i class="icon-mat bi bi-x-lg" mat-dialog-close></i>
  </div>
</div>

<mat-dialog-content>
  <div class="row" *ngIf="renderData?.format === 'pdf'">
    <div class="col-12">
      <pdf-viewer
        [src]="blobUrl"
        [(page)]="page"
        [show-all]="showAll"
        [fit-to-page]="fitToPage"
        [zoom]="zoom"
        [zoom-scale]="zoomScale"
        [stick-to-page]="stickToPage"
        [show-borders]="false"></pdf-viewer>
    </div>
  </div>

  <div class="row" *ngIf="renderData?.format !== 'pdf'">
    <div class="col-12">
      <img [src]="this.renderImage" alt="{{ renderData?.format }}" />
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    *ngIf="renderData?.format === 'pdf'"
    (click)="printLabel()"
    class="primary-btn"
    type="button">
    {{'global.print' | translate}}
  </button>
  <button (click)="downloadLabel(renderData?.format)" class="ms-2 secondary-btn" type="button">
    {{'global.download' | translate}}
  </button>
</mat-dialog-actions>
